<script setup lang="ts">
/**
 * El portal no tiene landing: `/` es la pantalla de login. Se conserva la ruta
 * (hay links viejos apuntando a la raíz) y se redirige a `/login`, que es donde
 * vive la vista real.
 */
definePage({
  redirect: '/login',
  meta: { public: true },
})
</script>

<template>
  <div />
</template>
